import React from "react";
import { Bar } from "react-chartjs-2";
import "chartjs-plugin-datalabels";

const QuarteryChart = () => {
const chartData = [
  {
    January: [
      {
        location: {
          id: 101,
          name: "Nyarugenge",
        },
        currentTargetAmount: 138464814,
        totalCollectedAmount: 38071122,
      },
      {
        location: {
          id: 102,
          name: "Gasabo",
        },
        currentTargetAmount: 185840947,
        totalCollectedAmount: 10088365,
      },
      {
        location: {
          id: 103,
          name: "Kicukiro",
        },
        currentTargetAmount: 129176301,
        totalCollectedAmount: 66993718,
      },
    ],
  },
  {
    February: [
      {
        location: {
          id: 101,
          name: "Nyarugenge",
        },
        currentTargetAmount: 147599879,
        totalCollectedAmount: 37059448,
      },
      {
        location: {
          id: 102,
          name: "Gasabo",
        },
        currentTargetAmount: 192903594,
        totalCollectedAmount: 17953180,
      },
      {
        location: {
          id: 103,
          name: "Kicukiro",
        },
        currentTargetAmount: 147679676,
        totalCollectedAmount: 70587645,
      },
    ],
  },
  {
    March: [
      {
        location: {
          id: 101,
          name: "Nyarugenge",
        },
        currentTargetAmount: 125633245,
        totalCollectedAmount: 46494495,
      },
      {
        location: {
          id: 102,
          name: "Gasabo",
        },
        currentTargetAmount: 93571806,
        totalCollectedAmount: 13077842,
      },
      {
        location: {
          id: 103,
          name: "Kicukiro",
        },
        currentTargetAmount: 1041189098,
        totalCollectedAmount: 75278968,
      },
    ],
  },
];

 const januaryData = chartData.find((month) => month.hasOwnProperty("January"));
 const februaryData = chartData.find((month) =>
   month.hasOwnProperty("February")
 );
 const marchData = chartData.find((month) => month.hasOwnProperty("March"));

 // Collecting the collected amounts for each district in each month
 const nyarugengeCollected = [
   januaryData.January.find((data) => data.location.name === "Nyarugenge")
     .totalCollectedAmount,
   februaryData.February.find((data) => data.location.name === "Nyarugenge")
     .totalCollectedAmount,
   marchData.March.find((data) => data.location.name === "Nyarugenge")
     .totalCollectedAmount,
 ];

 const kicukiroCollected = [
   januaryData.January.find((data) => data.location.name === "Kicukiro")
     .totalCollectedAmount,
   februaryData.February.find((data) => data.location.name === "Kicukiro")
     .totalCollectedAmount,
   marchData.March.find((data) => data.location.name === "Kicukiro")
     .totalCollectedAmount,
 ];

 const gasaboCollected = [
   januaryData.January.find((data) => data.location.name === "Gasabo")
     .totalCollectedAmount,
   februaryData.February.find((data) => data.location.name === "Gasabo")
     .totalCollectedAmount,
   marchData.March.find((data) => data.location.name === "Gasabo")
     .totalCollectedAmount,
 ];

 // Chart data
 const data = {
   labels: ["Nyarugenge", "Kicukiro", "Gasabo"],
   datasets: [
     {
       label: "January",
       backgroundColor: "rgba(255, 99, 132, 0.5)",
       borderColor: "rgba(255, 99, 132, 1)",
       borderWidth: 1,
       hoverBackgroundColor: "rgba(255, 99, 132, 0.8)",
       hoverBorderColor: "rgba(255, 99, 132, 1)",
       data: nyarugengeCollected,
     },
     {
       label: "February",
       backgroundColor: "rgba(54, 162, 235, 0.5)",
       borderColor: "rgba(54, 162, 235, 1)",
       borderWidth: 1,
       hoverBackgroundColor: "rgba(54, 162, 235, 0.8)",
       hoverBorderColor: "rgba(54, 162, 235, 1)",
       data: kicukiroCollected,
     },
     {
       label: "March",
       backgroundColor: "rgba(255, 206, 86, 0.5)",
       borderColor: "rgba(255, 206, 86, 1)",
       borderWidth: 1,
       hoverBackgroundColor: "rgba(255, 206, 86, 0.8)",
       hoverBorderColor: "rgba(255, 206, 86, 1)",
       data: gasaboCollected,
     },
   ],
   plugins: {
     datalabels: {
       anchor: "end",
       align: "top",
     },
   },
 };
 return (
   <div>
     <h4>Collected Amount by District</h4>
     <Bar data={data} />
   </div>
 );
};

export default QuarteryChart;


